const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

class SalesPopupEventService {
  /**
   * Genera o obtiene un session ID único
   */
  static getSessionId() {
    let sessionId = sessionStorage.getItem('sales_popup_session_id');
    if (!sessionId) {
      sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      sessionStorage.setItem('sales_popup_session_id', sessionId);
    }
    return sessionId;
  }

  /**
   * Trackea un evento del popup
   */
  static async trackEvent(eventType, additionalData = {}) {
    try {
      const sessionId = this.getSessionId();
      const timeOnPage = this.getTimeOnPage();
      const scrollDepth = this.getScrollDepth();

      const eventData = {
        event_type: eventType,
        session_id: sessionId,
        time_on_page: timeOnPage,
        scroll_depth: scrollDepth,
        ...additionalData,
      };

      const response = await fetch(`${API_BASE_URL}/sales-popup/event/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(eventData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error tracking sales popup event:', error);
      // No lanzar error para no interrumpir la experiencia del usuario
      return null;
    }
  }

  /**
   * Trackea una impresión (cuando el popup se muestra)
   */
  static async trackImpression() {
    return this.trackEvent('impression');
  }

  /**
   * Trackea un cierre (cuando el popup se cierra sin acción)
   */
  static async trackClose() {
    return this.trackEvent('close');
  }

  /**
   * Trackea un click en el botón
   */
  static async trackButtonClick() {
    return this.trackEvent('button_click');
  }

  /**
   * Calcula el tiempo en página desde que se cargó
   */
  static getTimeOnPage() {
    const pageLoadTime = performance.timing.navigationStart || performance.timeOrigin;
    const currentTime = Date.now();
    return Math.round((currentTime - pageLoadTime) / 1000); // en segundos
  }

  /**
   * Calcula la profundidad de scroll
   */
  static getScrollDepth() {
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (documentHeight <= windowHeight) {
      return 100; // Si el contenido cabe en la pantalla, scroll depth es 100%
    }
    
    const scrollableHeight = documentHeight - windowHeight;
    const scrollDepth = (scrollTop / scrollableHeight) * 100;
    return Math.min(100, Math.max(0, Math.round(scrollDepth)));
  }
}

export default SalesPopupEventService;


